"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = exports.default = void 0;
var colors_1 = require("./colors");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return colors_1.colors; } });
var colors_2 = require("./colors");
Object.defineProperty(exports, "colors", { enumerable: true, get: function () { return colors_2.colors; } });
//# sourceMappingURL=index.js.map